/* eslint-disable import/prefer-default-export */

export const siteJson = {
  siteId: 630000,
  siteName: 'MissionSquare Research Institute',
  siteTitle: 'MissionSquare Research Institute',
  siteSubTitle: ' ',
  siteTag: ' ',
  siteDescription: ' ',
  welcomeTitle: 'Welcome to the MissionSquare Research Institute',
  contactUsEmail: '#MSRITeam',
  loginGreetingTitle: 'Welcome',
  isMultiSite: false,
  isMegaMenu: true,
  isWebUserReset: false,
  isProfile: false,
  isRunAs: false,
  isPublicMegaMenu: true,
  isSiteConfigurationEnabled: true,
  public: {
    isMegaMenu: true,
    defaultPath: '/home',
  },
  urlWhitelist: ['missionsq.org', 'msqretirement.org', 'icmarc.org'],
};
